import { render, staticRenderFns } from "./JobPage.vue?vue&type=template&id=66a78a6e&scoped=true&"
import script from "./JobPage.vue?vue&type=script&lang=js&"
export * from "./JobPage.vue?vue&type=script&lang=js&"
import style0 from "./JobPage.vue?vue&type=style&index=0&id=66a78a6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a78a6e",
  null
  
)

export default component.exports